module.exports = __webpack_public_path__ + "static/media/insert_comment_active.6adf29e0.svg";